module.exports = __webpack_public_path__ + "static/drinkMenu-1d0bd1792d6ed185e76bb9fefdc77ed5.pdf";